<template>
  <table>
    <tr>
      <th>Tid</th>
      <th>förbrukning [V]</th>
      <th>motor [V]</th>
      <th>luftfuktighet [%]</th>
      <th>temperatur [°C]</th>
    </tr> 
    <tr v-for="row in sorted_table" :key="row[0]">
      <td>{{new Date(parseInt(row[0])).toISOString()}}</td>
      <td>{{row[1]}}</td>
      <td>{{row[2]}}</td>
      <td>{{row[3]}}</td>
      <td>{{row[4]}}</td>
    </tr>
  </table>
</template>

<script>
import axios from "axios";

export default {
  data: function () {
    return {
      table: {}
    }
  },
  computed: {
    sorted_table: function() {
      let t = this.table
      return Object.keys(this.table).sort().reverse().map(function(key) { return t[key]})
    }
  },
  mounted () {
    let url = "https://roxy.lab.ovaielo.se/api/v1/metrics?samples=12"
    //let url = "http://localhost:8080/api/v1/metrics?samples=12"
    let convert_to_ms = function(v) {
      return {x: v.x*1000, y: v.y}
    }
    axios.get(url).then(
      response => {
      let new_table = {}
      let fill_table = function(values, index) {
        values.map(convert_to_ms).forEach(function(v) {
          if (!(v.x in new_table)) {
            new_table[v.x] = [v.x, 'n/a', 'n/a', 'n/a', 'n/a']
          }
          new_table[v.x][index + 1] = v.y
        })
      }
      fill_table(response.data.v_main, 0)
      fill_table(response.data.v_engine, 1)
      fill_table(response.data.humidity, 2)
      fill_table(response.data.temp, 3)
      this.table = new_table
    })
  }
}
</script>
